import { css } from "@linaria/core";
import { Header } from "../Card";

export const TableCardWithoutBorder = css`
  border: none;
  height: auto;

  ${Header} {
    padding: 24px 0 16px 0;
  }
`;

export const TableHeaderNoPaddingT = css`
  ${Header} {
    padding-top: 0;
  }
`;
